<template>
  <div>
    <div class="pageSections">
      <b-navbar
        v-b-scrollspy="{ offset: 0, method: 'auto' }"
        class="bg-faded"
      >
        <b-nav pills>
          <b-nav-item
            v-for="section in pageSections"
            :key="section.id"
            :href="'#' + section.id"
            ><span v-if="$i18n.locale=='en'">{{ section.title }}</span>
            <span v-if="$i18n.locale=='ar'">{{ section.title_ar }}</span>
            </b-nav-item
          >
        </b-nav>
      </b-navbar>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageSections: Array
  },
};
</script>

<style lang="scss" scoped>
.pageSections {
  .navbar {
    position: fixed;
    top: 50%;
    left: rem(15px);
    width: fit-content;
    transform: translateY(-50%);
    padding:0;
    z-index:99;
    .nav {
      display: flex;
      flex-direction: column;
      &-item {
        //border-left: solid 3px #8d8490;
        padding: 0px;
        a {
          font-size: rem(18px);
          font-weight: 700;
          background: none;
          text-transform: uppercase;
          height: rem(30px);
          position: relative;
          display: inline-block;
          padding: 0px;
          padding-left: rem(20px);
          @include flex(center, flex-start);
          color:#9f9f9f;
          &:before {
            position: absolute;
            content: "";
            width: 2px;
            height: 75%;
            background: #8d8490;
            left: 0px;
            top: 0px;
            top: 50%;
            transform: translateY(-50%);
          }
          @media screen and (max-width:1600px){
            // padding-left:0;
          }
          &.active{  
            color: black !important;
            font-weight: 900;
          }
          span {
            opacity: 0;
            // color: var#d31b88;
            padding-left: rem(12px);
          }
        }
        &:not(:last-child) {
          margin-bottom: 3px;
        }
        &.active, &:hover{
            a{
                color: #000;
                span{
                    opacity: 1;
                }
            }
        }
        &.active {
          a {
            background: none;
            span {
              opacity: 1;
              animation: fadeout 2s forwards;
            }
              &:hover{
              span {
                opacity: 1 !important;
              }
            }
          }
          
        }
        @media screen and (max-width: 1025px) {
          &:hover {
            a {
              span {
                opacity: 1 !important;
              }
            }
          }
        }
      }
    }
    @keyframes fadeout {
      0% {
        opacity: 1;
      }
      75% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }
  @media screen and (max-width: 991px) {
    display: none !important;
  }
}


// ar style


[lang="ar"]{
  .pageSections {
  .navbar {
    right: rem(15px);
    left:auto;
    .nav {
      &-item {
        a {

          padding-right: rem(20px);
          padding-left:0;
          margin-right: 2rem;
          margin-left:0;
          &:before {
            right: 0px;
            left:auto;

          }
          span {
            padding-right: rem(12px);
            padding-left:0;
          }
        }
      }
    }
  }
  }
}
</style>
